import { appendScriptToHead } from "../utils/utils";
import config from "../constants/config";
const { ENV_SUFIX } = config;
export default class GigyaService {
  static setUpCdcScript() {
    
    const cdcUrl = `https://${
      process.env[`REACT_APP_CDC_HOST_NAME${ENV_SUFIX}`]
    }/js/gigya.js?apiKey=${process.env[`REACT_APP_CDC_API_KEY${ENV_SUFIX}`]}`;
    appendScriptToHead(cdcUrl, false);
  }

  static setUpMfaCdcScript() {
    const apiKey = process.env[`REACT_APP_MFA_CDC_API_KEY${ENV_SUFIX}`];
    const hostName = process.env[`REACT_APP_CDC_HOST_NAME${ENV_SUFIX}`];
    const cdcUrl = `https://${hostName}/js/gigya.js?apiKey=${apiKey}`;
    appendScriptToHead(cdcUrl, false);
  }

  static setUpDcrCdcScript() {
    const apiKey = process.env[`REACT_APP_DCR_CDC_API_KEY${ENV_SUFIX}`];
    const hostName = process.env[`REACT_APP_CDC_HOST_NAME${ENV_SUFIX}`];
    const cdcUrl = `https://${hostName}/js/gigya.js?apiKey=${apiKey}`;
    appendScriptToHead(cdcUrl, false);
  }

  static setUpCloudCdcScript() {
    const apiKey = process.env[`REACT_APP_CLOUD_CDC_API_KEY${ENV_SUFIX}`];
    const hostName = process.env[`REACT_APP_CDC_HOST_NAME${ENV_SUFIX}`];
    const cdcUrl = `https://${hostName}/js/gigya.saml.js?apiKey=${apiKey}`;
    appendScriptToHead(cdcUrl, false);
  }

  static isSessionValid() {
    return new Promise(async (resolve) => {
      window.gigya ? resolve(true) : resolve(false);
    });
  }

  static getAccountInfo() {
    return new Promise(async (resolve, reject) => {
      window.gigya.accounts.getAccountInfo({
        callback: (response) =>
          response.errorCode === 0 ? resolve(response) : reject(response),
      });
    });
  }

  static setAccountInfo(params) {
    return new Promise((resolve, reject) => {
      window.gigya.accounts.setAccountInfo({
        ...params,
        callback: (response) => {
          response.errorCode === 0 ? resolve(response) : reject(response);
        },
      });
    });
  }

  static accountLogin(params, apiKey = null) {
    return new Promise((resolve, reject) => {
      window.gigya.accounts.login({
        ...params,
        ...(apiKey ? { apiKey } : {}),
        callback: (response) => {
          resolve(response);
        },
      });
    });
  }

  static finalizeRegistration(regToken) {
    return new Promise((resolve, reject) => {
      window.gigya.accounts.finalizeRegistration({
        regToken: regToken,
        callback: (response) => {
          try {
            resolve(response);
          } catch (error) {
            reject(response);
          }
        },
      });
    });
  }

  static initTFA(params) {
    return new Promise((resolve, reject) => {
      window.gigya.accounts.tfa.initTFA({
        ...params,
        callback: (response) => {
          if (response.errorCode === 0) {
            resolve(response);
          } else {
            reject(response);
          }
        },
      });
    });
  }
   // Show Gigya screenset
  static showScreenSet(screenSetName, startScreen, options = {}) {
    return new Promise((resolve, reject) => {
      if (!window.gigya || !window.gigya.accounts || !window.gigya.accounts.showScreenSet) {
        reject(new Error('Gigya is not available or showScreenSet method is not loaded'));
        return;
      }

      const defaultOptions = {
        screenSet: screenSetName,
        onAfterScreenLoad: function(eventObj) {
          
          // Debug available screens
          if (eventObj.response && eventObj.response.screens) {
          }
          if (eventObj.currentScreen) {
          }
          
          if (options.onAfterScreenLoad) options.onAfterScreenLoad(eventObj);
          resolve(eventObj);
        },
        onLogin: function(eventObj) {
          if (options.onLogin) options.onLogin(eventObj);
        },
        onHide: function(eventObj) {
          // Check why it was hidden
          if (eventObj.reason === 'finished' && eventObj.isFlowFinalized) {
            console.warn(`⚠️ Screenset closed immediately - possible issues:`, {
              reason: eventObj.reason,
              isFlowFinalized: eventObj.isFlowFinalized,
              startScreen: startScreen,
              possibleCause: startScreen ? `Screen '${startScreen}' might not exist` : 'Default screen configuration issue'
            });
          }
          
          if (options.onHide) options.onHide(eventObj);
        },
        onError: function(eventObj) {
          console.error(`❌ Error in screenset ${screenSetName}:`, eventObj);
          
          // Enhanced error logging
          console.error(`🔍 Error details:`, {
            errorCode: eventObj.errorCode,
            errorMessage: eventObj.errorMessage,
            errorDetails: eventObj.errorDetails,
            screenSet: screenSetName,
            startScreen: startScreen
          });
          
          if (options.onError) options.onError(eventObj);
          reject(eventObj);
        }
      };

      // Add startScreen if provided as parameter or in options
      if (startScreen) {
        defaultOptions.startScreen = startScreen;
      } else if (options.startScreen) {
        defaultOptions.startScreen = options.startScreen;
      } 

      // Merge custom options with default options
      const finalOptions = { ...defaultOptions, ...options, screenSet: screenSetName };
      

      try {
        window.gigya.accounts.showScreenSet(finalOptions);
      } catch (error) {
        console.error(`❌ Exception calling showScreenSet for ${screenSetName}:`, error);
        reject(error);
      }
    });
  }

  // Close any open screenset
  static closeScreenSet() {
    if (window.gigya && window.gigya.accounts && window.gigya.accounts.hideScreenSet) {
      try {
        window.gigya.accounts.hideScreenSet();
      } catch (error) {
        console.error('Error closing Gigya screenset:', error);
      }
    }
  }

  // Debug method to check available screensets
  static debugScreenSets() {
    if (!window.gigya || !window.gigya.accounts) {
      console.error('Gigya not available for debugging');
      return;
    }
    
    // Try to get screenset information
    if (window.gigya.accounts.getScreenSets) {
      try {
        window.gigya.accounts.getScreenSets({
          callback: function(response) {
          }
        });
      } catch (error) {
        console.warn('Could not retrieve screensets:', error);
      }
    }
  }

}
